import React from 'react'
import { IInputProps } from '../../../types/interfaces/IInputProps'
import { InputContainer, Input, Label } from '../input/style'
import { Error } from '../error/Error'
import { useAppSelector } from 'store/store'

export const PhoneInput: React.FC<IInputProps> = ({
  callback,
  hasError,
  errorText,
  className,
  value,
  disabled,
  labelText,
}) => {
  const isLoading = useAppSelector((state) => state.layout.isLoading)

  const regex = RegExp(/^05\d([-]{0,1})\d{7}$/)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    const error = !regex.test(e.target.value)
    callback(e.target.value, error)
  }

  return (
    <InputContainer
      className={`phone ${className ?? ''} ${hasError ? 'error' : ''}`}
    >
      <Label htmlFor="phone">{labelText}</Label>
      <Input
        title={disabled ? 'לא ניתן לערוך שדה זה' : ''}
        disabled={disabled || isLoading}
        value={value}
        type="number"
        name="phone"
        autoComplete="tel-local"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
      ></Input>
      <Error hasError={hasError} errorText={errorText}></Error>
    </InputContainer>
  )
}
